import cx from 'classnames';
import { t } from 'i18next';
import { TrackedLink } from '../link';

export const PATREON_CHECKOUT_URL = 'https://www.patreon.com/join/RaiderIO';

type TPatreonCheckoutLinkProps = {
  className?: string;
};

export function PatreonCheckoutLink({ className }: TPatreonCheckoutLinkProps) {
  return (
    <div
      className={cx('slds-text-align--center rio-patreon-checkout-link', className)}
      data-testid="patreon-checkout-link"
    >
      <TrackedLink
        href={PATREON_CHECKOUT_URL}
        target="_blank"
        as="patreon:checkout_link"
        className="rio-patreon-checkout-link__link"
        onClick={() =>
          // Distinguish this Xsolla-rail Patreon fallback (a checkout-intent
          // moment) from the generic outbound Patreon clicks it would otherwise
          // be conflated with. target=_blank still handles navigation.
          RIO_TRACK_EVENT('event', 'select_content', {
            content_type: 'premium_join_patreon',
            content_id: 'patreon_checkout_link'
          })
        }
      >
        <i className="fa-brands fa-patreon" aria-hidden="true" /> {t('xsolla:patreon-checkout-link')}
      </TrackedLink>
    </div>
  );
}
